module.exports = __webpack_public_path__ + "img/banner@2x.94ed7262.png";